import { jsxs as v, jsx as l } from "react/jsx-runtime";
function a(c) {
  return /* @__PURE__ */ v("svg", { fill: "none", height: "1em", viewBox: "0 0 14 14", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...c, children: [
    /* @__PURE__ */ l(
      "path",
      {
        clipRule: "evenodd",
        d: "M8.616 3.669l-.945-.125c-.056-.013-.113-.041-.14-.096l-.41-.844a.31.31 0 00-.55 0l-.423.83c-.028.055-.084.097-.14.097l-.945.124a.296.296 0 00-.17.512l.692.65c.042.041.07.096.056.166l-.17.926a.301.301 0 00.438.318l.846-.442c.056-.028.127-.028.169 0l.846.442c.225.125.479-.069.437-.318l-.17-.926c-.014-.056.015-.125.057-.166l.69-.65a.287.287 0 00-.168-.498z",
        fill: "#00182E",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        clipRule: "evenodd",
        d: "M12.07 1.65h-1.255V1a.435.435 0 00-.437-.428H3.3A.435.435 0 002.864 1v.664H1.609c-.804 0-1.466.65-1.466 1.438v.927c0 .968.592 1.811 1.494 2.17l1.861.72a4.057 4.057 0 001.833 1.507v1.867c-.804.041-1.438.677-1.438 1.48v1.023c0 .235.197.428.437.428h5.019c.24 0 .437-.193.437-.428v-1.024c0-.788-.635-1.438-1.438-1.48v-1.88a3.89 3.89 0 001.832-1.507l1.861-.72a2.31 2.31 0 001.509-2.17v-.927a1.482 1.482 0 00-1.48-1.438zM1.96 5.398a1.469 1.469 0 01-.958-1.37v-.926c0-.332.268-.595.606-.595h1.255v2.31c0 .345.056.677.14.995l-1.043-.414zm6.95 6.36v.609H4.768v-.609a.64.64 0 01.648-.636h2.862c.353 0 .635.29.635.636zm-1.423-1.48H6.205v-1.63c.211.027.423.054.648.054.226 0 .437-.027.649-.055v1.632h-.014zm-.649-2.42c-1.706 0-3.101-1.368-3.101-3.041V1.415H9.94v3.402c0 1.673-1.396 3.042-3.102 3.042zm5.837-3.83c0 .609-.38 1.148-.959 1.37l-1.043.4c.084-.317.14-.65.14-.995V2.507h1.255c.339 0 .607.263.607.595v.927z",
        fill: "#00182E",
        fillRule: "evenodd"
      }
    )
  ] });
}
export {
  a as default
};
